export enum SchemaComponentTypes{

    SELECT = 'select',
  
    SELECTICON = 'selectIcon',
  
    INPUT = 'input',
  
    INPUTNUMBER = 'inputNumber',
  
    TEXTAREA = 'textarea',
  
    DATEPICKER = 'datepicker',
  
    DATERANGEPICKER = 'dateRangePicker',
  
    YEARPICKER = 'yearPicker',
  
    RADIO = 'radio',
  
    LOOKUP = 'lookup',
  
    SELECT_SEARCH = 'select-search',
  
    POPUP_VIEW ='popup-view'
  
  }
  export enum ColTypeEnum {
    'a' = 'a',
    'icon' = 'icon',
    'innerHTML' = 'innerHTML',
    'tag' = 'tag',
    'multipleIcons' = 'multipleIcons'
  }